import { motion } from 'framer-motion';
import { Clock, Users, ImageOff, Puzzle } from 'lucide-react';

const painPoints = [
  {
    icon: Clock,
    title: 'Organisation chronophage',
    description:
      'Coordonner les visites, gérer les agendas et assurer le suivi prend un temps considérable à vos équipes.',
  },
  {
    icon: Users,
    title: 'Multiplication des prestataires',
    description:
      'Photographe, agent de visite, serrurier... Multiplier les interlocuteurs complique la gestion.',
  },
  {
    icon: ImageOff,
    title: 'Biens mal valorisés',
    description:
      'Des photos de mauvaise qualité ou des visites mal organisées peuvent ralentir la vente d\'un bien.',
  },
  {
    icon: Puzzle,
    title: 'Manque de solution centralisée',
    description:
      'Il n\'existait pas de partenaire unique capable de gérer l\'ensemble des besoins opérationnels.',
  },
];

export function PainPoints() {
  return (
    <section id="problemes" className="py-24 bg-cream/50">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-50 text-red-600 text-sm font-medium border border-red-200 mb-6"
          >
            Constat
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl font-display font-bold text-navy-600 mb-6"
          >
            Les défis du quotidien{' '}
            <span className="gradient-text">des notaires</span>
          </motion.h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {painPoints.map((point, index) => (
            <motion.div
              key={point.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="rounded-2xl bg-white border border-navy-100 shadow-sm p-8"
            >
              <div className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center mb-5">
                <point.icon className="w-6 h-6 text-red-500" />
              </div>
              <h3 className="text-lg font-display font-semibold text-navy-600 mb-3">
                {point.title}
              </h3>
              <p className="text-navy-300 leading-relaxed text-sm">{point.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
